export default __webpack_public_path__ + "static/media/EBGaramond-VariableFont_wght.baa0e0cf.ttf";